export const setFieldMutator = ([name, data], state) => {
    const field = state.fields[name];
    if (field) {
        field.data = Object.assign(Object.assign({}, field.data), data);
    }
};
